// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CHECKOUT_STEPS } from "@keller/App/Widgets/CheckoutStepper/CheckoutStepper.helper";
import { StepperContext } from "@keller/App/Widgets/CheckoutStepper/StepperContext";
import { color } from "@keller/XDL/Utilities";
import React, { useContext } from "react";
import { css } from "styled-components";

interface DidSomeoneHelpYouStyles {
    container?: InjectableCss;
    description?: TypographyProps;
}

const didSomeoneHelpYouStyles: DidSomeoneHelpYouStyles = {
    container: {
        css: css`
            padding: 16px;
            background: ${color("common.ui12")};
        `,
    },
    description: {
        size: 14,
        weight: "bold",
        lineHeight: "19px",
        css: css`
            display: block;
            margin-bottom: 20px;
        `,
    },
};

const styles = didSomeoneHelpYouStyles;
const DidSomeoneHelpYou = () => {
    const { currentStep, checkoutInfoState, updateCheckoutInfoState } = useContext(StepperContext);

    if (currentStep !== CHECKOUT_STEPS.REVIEW) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.description}>{siteMessage("Keller_DidSomeoneHelpYou")}</Typography>
            <TextField
                label={translate("Associate Name")}
                placeholder={translate("Associate's Full Name")}
                value={checkoutInfoState.associateName}
                onChange={event =>
                    updateCheckoutInfoState({
                        type: "update",
                        payload: { associateName: event.target.value || "" },
                    })
                }
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: DidSomeoneHelpYou,
    definition: {
        group: "Checkout - Review & Submit",
        allowedContexts: ["CheckoutReviewAndSubmitPage"],
        fieldDefinitions: [],
    },
};
export default widgetModule;
